import { z } from "zod";
import { USER_FLAGS } from "../flags.js";
export const userFlagSchema = z.enum(USER_FLAGS);
export const phoneSchema = z.string().regex(/^\+?\d{8,15}$/, "Ugyldig telefonnummer");
export const emailSchema = z.string().email("Ugyldig e-postadresse");
export const norwegianBankAccountSchema = z
    .string()
    .regex(/^\d{4}\.\d{2}\.\d{5}$|^\d{11}$/, "Ugyldig kontonummer");
export const isoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Bruk format YYYY-MM-DD");
export const timeStringSchema = z.string().regex(/^\d{2}:\d{2}$/, "Bruk format HH:MM");
export const settlementTypeSchema = z.enum(["GIFT_CARD", "PAYOUT"]);
export const offerResponseSchema = z.enum(["ACCEPTED", "DECLINED"]);
export const deliveryStatusSchema = z.enum(["ACTIVE", "ARCHIVED"]);
export const stoneHandlingSchema = z.enum(["REMOVE_AND_RETURN", "KEEP_AS_IS"]);
export const stoneRemovalChargeSchema = z.enum(["STONE_REMOVAL", "PAVE_STONE_REMOVAL"]);
export const stoneHandlingDetailsSchema = z.object({
    mode: z.enum(["NONE_OR_KEEP", "REMOVE_ALL", "REMOVE_ALL_GOLDSMITH", "SPECIFIC"]),
    selectedItemIndexes: z.array(z.number().int().min(0).max(49)).max(50).default([]),
    removalMethod: z.enum(["STANDARD", "GOLDSMITH"]).nullable().optional().default(null),
    note: z.string().max(500).nullable().optional().default(null),
});
export function firestoreDocument() {
    return z.custom(() => true);
}
export const updatedResponseSchema = z.object({ updated: z.literal(true) });
export const deletedResponseSchema = z.object({ deleted: z.literal(true) });
export const sentResponseSchema = z.object({ sent: z.literal(true) });
export const acknowledgedResponseSchema = z.object({ acknowledged: z.literal(true) });
export const recordedResponseSchema = z.object({ recorded: z.literal(true) });
export const cancelledResponseSchema = z.object({ cancelled: z.literal(true) });
export const healthResponseSchema = z.object({
    status: z.literal("ok"),
    surface: z.enum(["enduser", "admin"]),
    traceId: z.string().nullable(),
    aiConfigured: z.boolean(),
    environment: z.string().nullable(),
    region: z.string(),
    service: z.string().nullable(),
    revision: z.string().nullable(),
    runtime: z.literal("firebase-functions-v2"),
});
